module.exports = __webpack_public_path__ + "img/logo-hara.196b8c9e.png";